import React from 'react'
import { Link } from 'react-router-dom'
import moment from '../../../helpers/moment'
import * as Badges from '../../../components/badges'
import PropTypes from 'prop-types'
import {
  POOL_STATUS_INACTIVE,
  POOL_STATUS_OFFLINE,
  POOL_STATUS_ONLINE
} from '../../../constants/poolStatuses'
import { HIDE_POOL_SHIFTS } from '../../../constants/featureFlags'

const PoolRow = ({ pool, tenant, now, locationSearch }) => {
  if (now === undefined) {
    now = moment.utc()
  }
  let restaurantAnchors = pool.restaurants.map(r => (<a key={r.id} href={`/restaurants/${r.id}`}>{r.name}</a>))

  let activeDrivers = pool.activeShift === null ? '' : pool.activeShift.activeDrivers
  // Pool considered to be in Automatic mode (ppETA is provided by Partner) if a partner provided AvailabilityOverride (BestGuess) at least once in the last 6 hours (21600 seconds)
  if (pool.poolAvailabilityOverrideInSeconds !== null && pool.poolAvailabilityOverrideInSeconds < 21600) {
    activeDrivers = "Automatic"
  }

  let partnerLink
  if (pool.partnerId) {
    partnerLink = <a href={window.env.pm[tenant] + '/partnerinfo/' + pool.partnerId} target="_blank">{pool.partnerSubscriptionName}</a>
  }

  return (
    <tr>
      <td><Link to={{ pathname: '/pools/' + encodeURIComponent(pool.id), search: locationSearch }}>{pool.name}</Link></td>
      <td>{partnerLink}</td>
      <td>{intersperse(restaurantAnchors, ", ")}</td>
      {!HIDE_POOL_SHIFTS && <td>{activeDrivers}</td>}
      <td>{renderRemainingTime(pool, now)}</td>
      <td>{renderStatus(pool.status)}</td>
    </tr>
  )
}

// PropTypes definitions
const restaurantShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired
})

const activeShiftShape = PropTypes.shape({
  activeDrivers: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
})

const poolShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  restaurants: PropTypes.arrayOf(restaurantShape).isRequired,
  activeShift: PropTypes.oneOfType([activeShiftShape, PropTypes.oneOf([null])]),
  poolAvailabilityOverrideInSeconds: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  partnerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  partnerSubscriptionName: PropTypes.string,
  nextAvailablePickupTimeUtc: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  pickupAvailability: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  status: PropTypes.string.isRequired
})

PoolRow.propTypes = {
  pool: poolShape.isRequired,
  tenant: PropTypes.string.isRequired,
  now: PropTypes.object,
  locationSearch: PropTypes.string
}

PoolRow.defaultProps = {
  now: undefined,
  locationSearch: ''
}

const renderRemainingTime = (pool, now) => {
  if (pool.nextAvailablePickupTimeUtc === null) {
    return pool.pickupAvailability === null ? 'unknown' : pool.pickupAvailability
  }

  const nextAvailablePickupTimeUtc = moment.utc(pool.nextAvailablePickupTimeUtc)

  if (nextAvailablePickupTimeUtc <= now) {
    return 'immediate'
  }

  const duration = moment.duration(nextAvailablePickupTimeUtc.diff(now), 'milliseconds')
    .format("h [hours], m [mins]")
  const actualTime = nextAvailablePickupTimeUtc.local().format('Do MMMM YYYY, h:mm:ss a')

  return <abbr title={actualTime}>{duration}</abbr>
}

const renderStatus = (status) => {
  switch (status) {
  case POOL_STATUS_OFFLINE:
    return <Badges.Offline />
  case POOL_STATUS_INACTIVE:
    return <Badges.Inactive />
  case POOL_STATUS_ONLINE:
    return <Badges.Online />
  default:
    return <Badges.Unknown />
  }
}

/* intersperse: Return an array with the separator interspersed between
 * each element of the input array.
 *
 * > _([1,2,3]).intersperse(0)
 * [1,0,2,0,3]
 */
const intersperse = (arr, sep) => {
  if (arr.length === 0) {
    return []
  }

  return arr.slice(1).reduce(function (xs, x) {
    return xs.concat([sep, x])
  }, [arr[0]])
}

export default PoolRow



// WEBPACK FOOTER //
// ./src/containers/pools/index/poolRow.js